import { ResultHeader } from './result-header'
import { ResultVerifications } from './result-verifications'
import { ResultPendingDocuments } from './result-pending-documents'
import { ResultObservations } from './result-observations'

export const AccessResult = ({ result, children }) => {
  if (!result) return null

  return (
    <div className={`w-full ${result.access ? 'text-green-600' : 'text-red-600'}`}>
      <ResultHeader
        displayDoc={result.displayDoc}
        fullName={result.data?.full_name}
        employeeRole={result.data?.employee_role_name}
        companyName={result.data?.company_name}
        message={result.message}
      />
      <ResultVerifications verifications={result.detail?.verifications} />
      <ResultPendingDocuments documents={result.detail?.pending_documents} />
      <ResultObservations observations={result.observations} />
      {children}
    </div>
  )
}

export {
  ResultHeader,
  ResultVerifications,
  ResultPendingDocuments,
  ResultObservations
}
